import { render, staticRenderFns } from "./OutboxAttachments.vue?vue&type=template&id=73061bd4&scoped=true"
import script from "./OutboxAttachments.vue?vue&type=script&lang=js"
export * from "./OutboxAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73061bd4",
  null
  
)

export default component.exports